import React from 'react'
import StickerEmbedModalContainer from 'shared/containers/sticker-embed-modal'
import SiteContainer from '../../site-container'
import Channel from '../containers/channel'

const App = ({ query, total, gridType, isOwner, contextId, id, groupId }) => (
    <SiteContainer>
        <StickerEmbedModalContainer channelId={parseInt(id)} />
        <Channel
            query={query}
            total={total}
            channelId={parseInt(id)}
            channelType={contextId}
            gridType={gridType}
            isOwner={isOwner}
            groupId={groupId}
        />
    </SiteContainer>
)

export default App
